import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { rankingBoards } from "@/mocks/rankings";

export default function RankingPreview() {
  const boards = rankingBoards.slice(0, 2);
  return (
    <section className="mx-auto max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="盘点榜单"
        title="本周都在看的合集排行"
        desc="按阅读、收藏与新上线时间整理的榜单，帮你快速找到值得花时间的那几条专题。"
        action={
          <Link
            to="/rankings"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部榜单
            <i className="ri-arrow-right-line text-base" />
          </Link>
        }
      />
      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {boards.map((board) => (
          <div
            key={board.id}
            className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <div className="flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-4">
              <h3 className="font-heading text-lg font-bold text-foreground-950">{board.title}</h3>
              <span className="text-xs text-foreground-500">更新于 {board.updated}</span>
            </div>
            <ol className="mt-2 divide-y divide-background-200">
              {board.items.slice(0, 5).map((item) => (
                <li key={item.rank}>
                  <Link
                    to={`/topics/${item.topicId}`}
                    className="group flex items-center gap-4 py-3.5"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        item.rank <= 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-0.5 block truncate text-xs text-foreground-500">
                        {item.note}
                      </span>
                    </span>
                    <span className="hidden shrink-0 text-xs text-secondary-700 sm:block">
                      {item.metric}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
}